<template>
	<div class="layout-container">
    <Layout>
      <Header class="header" v-if="routeName !== 'aiDetectionReport' && routeName !== 'llm'">
				 <ul>
          <li class="tab-list " :class="{ 'checkouttab': routeName == 'main' }">
						<router-link class="checktab" to="main">场景流程</router-link>
					</li>
          <li class="tab-list" :class="{ 'checkouttab': routeName == 'variable' }">
						<router-link  class="checktab" to="variable">流程设置</router-link>
					</li>
          <li class="tab-list" :class="{ 'checkouttab': routeName == 'intent' }">
						<router-link class="checktab" to="intent">意图管理</router-link>
					</li>
          <li class="tab-list" :class="{ 'checkouttab': routeName == 'knowledge' }">
						<router-link class="checktab" to="knowledge">问答知识库</router-link>
					</li>
          <li class="tab-list" :class="{ 'checkouttab': routeName == 'rules' }">
						<router-link class="checktab" to="rules">挂机处理</router-link>
					</li>
          <li class="tab-list" :class="{ 'checkouttab': routeName == 'eventRules' }">
						<router-link class="checktab" to="eventRules">事件</router-link>
					</li>
          <li v-if="isShowTextEditor || access.textEditor || [1, 283, 500041].includes(company.agent)" class="tab-list" :class="{ 'checkouttab': routeName == 'texteditor' }">
						<router-link class="checktab" to="texteditor">文本替换</router-link>
					</li>
          <li v-if="access.flowAiGenerate" class="tab-list" :class="{ 'checkouttab': routeName == 'aiDetection' }">
						<router-link class="checktab" to="aiDetection">AI话术检测</router-link>
					</li>
          <li class="tab-list" :class="{ 'checkouttab': routeName == 'debugger' }">
						<router-link class="checktab" to="debugger">调试器</router-link>
          </li>
          <li class="tab-list" :class="{ 'checkouttab': routeName == 'nodeHitRate' }">
						<router-link class="checktab" to="nodeHitRate">节点到达率</router-link>
					</li>
        </ul>
        <div class="header-right">
          <Button @click="openAiChat" style="margin-right: 15px" type="success">AI助理</Button>
          <Poptip v-if="showWeappCon" :title="agentIsGooki ? '复制链接在微信中打开或者微信扫码' : '使用微信扫码打开'" placement="bottom-end" @on-popper-show="copyShow">
            <div slot="content" class="weappCon">
              <Input v-if="agentIsGooki" id="foo" enter-button :value="weappUrl" style="width: 300px">
                <Button slot="append" icon="ios-copy" ref="weappCopyBtn" data-clipboard-target="#foo"></Button>
              </Input>
              <canvas ref="weappQrCode" class="weappQrCode"></canvas>
            </div>
            <a @click="recorder" data-clipboard-text="test">小程序录音</a>
          </Poptip>
        </div>
			</Header>
      <Content class="body">
				<router-view></router-view>
			</Content>
      <AiChat :open="showAiChat" title="AI智能对话" :quote="{
        type: 'scene',
        data: scene
      }" @on-close="showAiChat = false">
      </AiChat>
    </Layout>
	</div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getRecorderTokenA, getCompanyInfoA, getCompanyConfigA } from '@/server/api'
import ClipboardJS from 'clipboard'
import QRCode from 'qrcode'
import AiChat from '@/views/aiChat/index'

export default {
  data() {
    return {
      weappUrl: '',
      weappCopyBtn: undefined,
      agentIsGooki: false,
      showWeappCon: false,
      showAiChat: false,
    }
  },
  components: {
    AiChat
  },
	computed: {
    ...mapState('scene', ['sceneId', 'scene']),
		routeName() {
			return this.$route.name
		},
    isShowTextEditor() {
      return window.isOperator
    },
    ...mapState('user', ['access', 'company']),
	},
  methods: {
    ...mapActions('user', ['setCompany', 'setPermission']),
    recorder() {
      getRecorderTokenA({
        sceneId: this.sceneId
      }).then(res => {
        if (res.code !== 200) return;
        let flowService = webConfig.api.flowservice
        if (location.host === 'obot-designer.link263.cc') {
          flowService = 'https://oflowservice.link263.cc/launch-weapp'
        }
        const url = `${flowService}?token=${res.data}`
        this.weappUrl = url
        QRCode.toCanvas(this.$refs.weappQrCode, url, function (error) {
          if (error) console.error(error)
          console.log('success!');
        })
      })
    },
    copyShow() {
      if (this.weappCopyBtn) return
      const weappCopyBtn = new ClipboardJS(this.$refs.weappCopyBtn.$el);
      weappCopyBtn.on('success', (e) => {
        this.$Message.success('复制成功');
      });

      weappCopyBtn.on('error', (e) => {
        this.$Message.success('复制失败');
      });
      this.weappCopyBtn = weappCopyBtn
    },
    // 判断是什么代理商
    judgmentAgent() {
      if (window.isAdmin === true) return
      getCompanyInfoA().then(res => {
        this.agentIsGooki = res.data.agent === 2
        this.showWeappCon = res.data.agent !== 213
        this.setCompany(res.data)
      })
    },
    getCompanyConfig() {
      if (window.isAdmin === true) return
      getCompanyConfigA().then(res => {
        this.setPermission(res.data.permission || {})
      })
    },
    openAiChat() {
      this.showAiChat = true
      
    }
  },
  created() {
    if (window.isAdmin !== true) {
      this.judgmentAgent()
      this.getCompanyConfig()
    }
  }
}
</script>
<style lang="scss" scoped>
.layout-container {
  height: 100%;
  display: flex;
  background-color: #eee;
}
.list-style{
  display: flex;
  justify-content: center;
  height: 90px;
  align-items: center;
  border-bottom: 1px solid #dedede;
	cursor: pointer;
	span{
		font-size: 12px;
		color: #999
	}
	p{
		font-size: 14px;
		color: #333;
	}
}
.add-style{
	display: flex;
  justify-content: center;
  height: 70px;
  align-items: center;
  border-bottom: 1px solid #dedede;
	cursor: pointer;
}
.add-btn {
  width: 120px;
  height:40px;
  line-height: 40px;
  border-radius: 40px;
  border: 1px solid #dedede;
  text-align: center;
}
.left {
  width: 180px;
  height: 100%;
  display: inline-block;
  background-color: #fff;
	border-right: 1px solid #eee;
	margin-right: 10px;
}
.header {
  height: 50px;
  width: 100%;
  background-color: #f3f3f3;
  .tab-list {
    float: left;
    cursor: pointer;
    height: 50px;
    padding: 0 20px;
    line-height: 50px;
    font-size: 14px;
    color: #999;
  }
  .checkouttab {
    color: #6186cf;
    border-bottom: 4px solid #83a2d4;
		.checktab{
			color: #6186cf;
		}
  }
}
.main {
  display: inline-block;
  width: 100%;
  height: 100%;
  margin-left: 10px;
}
.body{
  height: 100%;
  background-color: #fff;
}
li, ul{
  list-style: none;
}
a{
	color: #999;
	display: inline-block;
	height: 50px;
}
.active{
	background-color: #f6f7fa;
	border-left: 4px solid #83a2d4;
}
.header-right {
  text-align: right;
  line-height: 50px;
}
.weappCon {
  text-align: center;
}
.weappQrCode {
  width: 196px;
  height: 196px;
}
</style>
